module.exports = __webpack_public_path__ + "static/media/paragraph.0f471031.svg";